import React, { useContext, useState } from "react";
import logo from "./../media/goldlogo-crop.png";
import { Link } from "react-router-dom";
import { FaFacebookF, FaYoutube, FaTwitter } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { Tooltip as ReactTooltip } from "react-tooltip";
import hand from "./media/righthand.gif";
import "./Footerr.css";
import { useMediaQuery } from "react-responsive";
import { CookiesDialog } from "../Cookies/CookiesMain";
import toast from "react-hot-toast";
import { AuthContext } from "../../Context/AuthContextProvider";
import Lottie from "lottie-react";
import thankyou from "./../../../src/Assets/Media/LottiesJSONs/Thankyou.json";
const Footerr = () => {
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { addSubscriber } = useContext(AuthContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(input)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      const response = await addSubscriber(input);

      // Check if the email is already subscribed
      if (response.alreadySubscribed) {
        setIsModalOpen(false); // Close the modal if already subscribed
        toast.error(
          "You are already with us. For specific concerns contact us."
        );
      } else {
        document.getElementById("Subscriber_modal").showModal();
        setIsModalOpen(true);
        toast.success("Subscription successful!");
      }
    } catch (error) {
      toast.error("Failed to subscribe: " + error.message);
    } finally {
      setInput("");
      setIsLoading(false);
    }
  };
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      {" "}
      <div className=" footer-box">
        <div className="upper  items-center  border-b footer-part-one ">
          <div className="container a-container a-padding">
            <div className="pb-[3rem] !text-center">
              <h2 className="font-bold lg:text-5xl md:text-3xl text-2xl my-2 title mb-[25px]   !leading-[140%] !text-center">
                Embrace digital transformation with .gold!
              </h2>
              <p className="mx-auto text-base paragraph">
                Own, invest, and grow with the world’s most exclusive digital
                assets - .gold domains that define prestige and power.
              </p>
            </div>
            <div className="  ">
              <form
                onSubmit={handleSubmit}
                className="flex flex-row subscribe-form"
                action="#"
              >
                <input
                  onChange={(e) => setInput(e.target.value)}
                  type="email"
                  value={input}
                  placeholder="Your Email"
                  className={`${
                    isMobile ? "w-full" : "w-[50%]"
                  } bg-transparent border-[2px] !border-[#b99653] rounded-[15px] px-[8px] min-h-[50px]`}
                />
                <button type="submit" className={`md:w-[50%] w-full white-btn`}>
                  {isLoading ? "Subscribing..." : "Subscribe"}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="bg-[#101c4c] container a-container">
          <div className="  footer-part-two row a-padding">
            <div className="col-md-6 col-lg-4 md:pr-[24px]">
              <div>
                <Link to="/" onClick={scrollToTop}>
                  <img src={logo} alt="" className="footer-logo" />
                </Link>
              </div>
              <p className="text-gray-500  !text-white paragraph-white mt-[20px] ">
                The most sought after and premium .gold domains are waiting for
                you!
              </p>
            </div>
            <div className="col-md-6 col-lg-3 ">
              <h2 className="text-2xl font-bold mb-2 md:mt-[10px] text-white ">
                Quick Links
              </h2>
              <ul className="text-white flex flex-col">
                <Link to="/Marketplace" className="timeline-item-content">
                  <li className="footer_links text-underline">
                    Domain Marketplace
                  </li>
                </Link>
                <Link
                  to="/sell-your-dot-gold-domain"
                  className="timeline-item-content"
                >
                  <li className="footer_links text-underline">List a Domain</li>
                </Link>
              </ul>
            </div>
            <div className="col-md-6 col-lg-2 ">
              <h2 className="text-2xl font-bold mb-2 md:mt-[10px] text-white">
                Connect
              </h2>
              <ul className="text-white flex flex-col">
                <Link to="/Terms" className="timeline-item-content">
                  <li className="footer_links text-underline">
                    Terms & Conditions
                  </li>
                </Link>
                <Link
                  to="/Refund-Cancellation"
                  className="timeline-item-content"
                >
                  <li className="footer_links text-underline">
                    Refund & Cancellation
                  </li>
                </Link>
                <Link to="/PrivacyPolicy" className="timeline-item-content">
                  <li className="footer_links text-underline">
                    Privacy Policy
                  </li>
                </Link>
                <Link to="/PricingPolicy" className="timeline-item-content">
                  <li className="footer_links text-underline">
                    Pricing Policy
                  </li>
                </Link>

                <Link to="/marketplace-help" className="timeline-item-content">
                  <li className="footer_links text-underline">Help</li>
                </Link>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3">
              <h2 className="text-2xl font-bold mb-2 md:mt-[10px] text-white ">
                Contact
              </h2>
              <ul className="text-white text-[18px] text-[#ffffffdb] leading-[28px]">
                <li className="">
                  <a href="mailto: info@terces.io" id="mail">
                    <span className="inline-block">
                      <img src={hand} alt="" className="blog-hand1" />
                    </span>
                    <span className="footer-link123">
                      marketplace@getbrand.gold{" "}
                    </span>
                  </a>
                  <ReactTooltip
                    anchorId="mail"
                    place="left"
                    content="Write to us"
                    className="copy-box-home-vision"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-part-three container a-container">
          <div className="flex  terms-part-footer">
            {/* <Link className="footer-link123">Privacy</Link> */}
            <Link to="/Terms" className="timeline-item-content !gap-0">
              <li className="footer_links text-underline">Terms</li>
            </Link>
            <CookiesDialog />
          </div>
          <div className="flex gap-[30px]">
            <a
              href="https://www.facebook.com/people/Branddot-Gold/pfbid02yFDgEAM3Wto4ErvvA6FnmbKJM1B7DExeAQ8snB6pjLBB6WnFwVbLY9LTCeKBjpgHl/"
              className="bg-white p-[6px] rounded-[15px] t-footer-icon"
              id="mission-div"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF className="text-[#002549] fb " />
            </a>
            <ReactTooltip
              anchorId="mission-div"
              place="top"
              content="Like Us"
              className="copy-box-home-vision"
            />
            <a
              href="https://www.youtube.com/@branddotgold"
              className="bg-white p-[6px] rounded-[15px] t-footer-icon"
              id="mission-div1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube className="text-[#002549] yt" />
            </a>
            <ReactTooltip
              anchorId="mission-div1"
              place="top"
              content="Subscribe Us"
              className="copy-box-home-vision"
            />
            <a
              href="https://www.instagram.com/branddotgold"
              className="bg-white p-[6px] rounded-[15px]  t-footer-icon"
              id="mission-div2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <RiInstagramFill className="text-[#002549] insta" />
            </a>
            <ReactTooltip
              anchorId="mission-div2"
              place="top"
              content="Follow Us"
              className="copy-box-home-vision"
            />
         
          </div>
          <dialog id="Subscriber_modal" className="modal text-center">
            <div
              className="modal-box modal-box-graident-border text-center"
              style={{ overflow: "hidden" }}
            >
              <div className="main-bg p-[20px]  rounded-[12px]">
                <form method="dialog">
                  <button className="btn btn-sm btn-circle btn-ghost absolute justify-right top-2 right-2">
                    ✕
                  </button>
                </form>

                <Lottie
                  animationData={thankyou}
                  loop
                  autoplay
                  style={{
                    width: isMobile ? "200px" : "400px",
                    height: isMobile ? "200px" : "400px",
                    background: "transparent",
                    scale: 5,
                    margin: "auto",
                  }}
                />
                <h1 className=" !text-[black] !text-[26px]">
                  Thanks for subscribing!
                </h1>
                <p className="py-4 !text-[black] !text-[20px]">
                  You will be the first to know about our newsletter.
                </p>
              </div>
            </div>
          </dialog>
        </div>
      </div>
    </>
  );
};

export default Footerr;
